import { FC } from 'react';
import seoPages from 'shared/config/seo-pages.json';
import { Courses } from 'widgets/courses';
import { Footer } from 'widgets/footer/ui';
import styles from './styles.module.scss';

export type SeoPageConfig = (typeof seoPages)[number];
type SeoSection = { heading: string; paragraphs?: string[]; bullets?: string[] };

const pageByPath = new Map(seoPages.map(page => [page.path, page]));

export const SeoPage: FC<{ page: SeoPageConfig }> = ({ page }) => {
    if (page.kind === 'contacts') {
        return <main className={styles.contactPage}><Footer pageTitle={page.heading} /></main>;
    }
    const format = page.path === '/programmirovanie-grozny/' ? 'offline'
        : page.path === '/programmirovanie-online/' ? 'online' : undefined;
    const related = page.relatedPaths?.map(path => pageByPath.get(path)).filter(Boolean);
    const singleCourse = page.kind === 'course';

    return (
        <main className={styles.page}>
            <div className={styles.inner}>
                <nav className={styles.breadcrumbs} aria-label="Хлебные крошки">
                    <a href="/">Главная</a>
                    {page.kind === 'course' && <a href="/courses/">Курсы</a>}
                    <span aria-current="page">{page.label}</span>
                </nav>
                <header className={styles.heading}>
                    <h1>{page.heading}</h1>
                    <p>{page.intro}</p>
                </header>
                <div className={singleCourse ? styles.singleCourse : undefined}>
                    <Courses embedded courseIds={page.courseIds} format={format}
                        showProgramLinks={page.kind === 'catalog' || page.kind === 'format'} />
                    <div className={styles.explanations}>
                        {page.sections?.map((section: SeoSection) => (
                            <section key={section.heading}>
                                <h2>{section.heading}</h2>
                                {section.paragraphs?.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
                                {section.bullets?.length ? <ul>{section.bullets.map(bullet => <li key={bullet}>{bullet}</li>)}</ul> : null}
                            </section>
                        ))}
                    </div>
                </div>
                {page.faq?.length ? <section className={styles.faq} aria-labelledby="faq-title">
                    <h2 id="faq-title">Вопросы об обучении</h2>
                    {page.faq.map(item => <details key={item.question}>
                        <summary>{item.question}</summary><p>{item.answer}</p>
                    </details>)}
                </section> : null}
                {related?.length ? <nav className={styles.related} aria-label="Другие программы и форматы">
                    {related.map(item => item && <a key={item.path} href={item.path}>{item.label}</a>)}
                </nav> : null}
            </div>
        </main>
    );
};
